import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const RemovePersonIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M11.25 6.66732c0-1.84167-1.49167-3.33334-3.33333-3.33334-1.84167 0-3.33334 1.49167-3.33334 3.33334 0 1.84166 1.49167 3.33338 3.33334 3.33338 1.84166 0 3.33333-1.49172 3.33333-3.33338Zm-1.66667 0c0 .91666-.75 1.66666-1.66666 1.66666C7 8.33398 6.25 7.58398 6.25 6.66732c0-.91667.75-1.66667 1.66667-1.66667.91666 0 1.66666.75 1.66666 1.66667ZM1.25 15.0007v1.6666h13.3333v-1.6666c0-2.2167-4.4416-3.3334-6.66663-3.3334-2.225 0-6.66667 1.1167-6.66667 3.3334Zm1.66667 0c.16666-.5917 2.75-1.6667 5-1.6667 2.24163 0 4.80833 1.0667 5.00003 1.6667H2.91667ZM18.75 8.33398h-5v1.66672h5V8.33398Z" />
  </Icon>
);

export default memo(RemovePersonIcon);
